<app-form (submit)="submitForm()" data-modal-backdrop-static>
    <div class="card">
        <div class="card-header location-modal-header">
            <h3 *ngIf="isNewLocation && addressStep === 'lookup'" class="card-header-title">New location – find address</h3>
            <h3 *ngIf="isNewLocation && addressStep === 'details'" class="card-header-title">New location</h3>
            <h3 *ngIf="!isNewLocation" class="card-header-title notranslate">
                {{ info.name ? (info.name + ' - ') : '' }}{{ refDataUtils.addressFormatter(info.address) }}
            </h3>
            <div class="location-modal-close-zone">
                <button type="button" class="btn-close location-modal-close" (click)="requestClose()"
                        aria-label="Close"></button>
            </div>
        </div>
        <div *ngIf="addressStep === 'lookup'" class="card-body address-lookup-step">
            <p class="text-secondary mb-4">Enter the postcode and house number to retrieve the address, coordinates and available energy-label data.</p>
            <div class="row">
                <div class="col-12 col-md-5">
                    <app-form-field label="Zipcode">
                        <input [ngModel]="addressLookup.zipCode"
                               (ngModelChange)="addressLookupChanged('zipCode', $event)"
                               type="text" class="form-control"
                               autocomplete="postal-code" placeholder="1234 AB" required
                               pattern="[1-9][0-9]{3}\s?[A-Za-z]{2}">
                    </app-form-field>
                </div>
                <div class="col-8 col-md-4">
                    <app-form-field label="House number">
                        <input [ngModel]="addressLookup.number"
                               (ngModelChange)="addressLookupChanged('number', $event)"
                               type="text" inputmode="numeric"
                               class="form-control" required pattern="[0-9]+">
                    </app-form-field>
                </div>
                <div class="col-4 col-md-3">
                    <app-form-field label="Addition">
                        <input [ngModel]="addressLookup.addition"
                               (ngModelChange)="addressLookupChanged('addition', $event)"
                               type="text" class="form-control">
                    </app-form-field>
                </div>
            </div>

            <div *ngIf="addressLookupState === 'searching'" class="address-lookup-progress" aria-live="polite">
                <div class="address-lookup-progress-item is-active">
                    <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                    <span>Retrieving BAG address data…</span>
                </div>
                <div class="address-lookup-progress-item is-waiting">
                    <i class="bi bi-circle" aria-hidden="true"></i>
                    <span>EP-Online starts after BAG</span>
                </div>
            </div>
            <div *ngIf="addressLookupState === 'not-found'" class="alert alert-warning mb-0">
                No exact address was found. Check the details or continue with manual entry.
            </div>
            <div *ngIf="addressLookupState === 'error'" class="alert alert-warning mb-0">
                The address service is temporarily unavailable. Try again or continue with manual entry.
            </div>
            <div *ngIf="addressLookupState === 'found'" class="address-lookup-result">
                <div class="address-lookup-result-heading">
                    <i class="bi bi-check-circle-fill"></i>
                    <div>
                        <div class="fw-semibold">Address found</div>
                        <div class="notranslate">{{ resolvedAddressLine() }}</div>
                    </div>
                </div>
                <ul class="address-lookup-checks">
                    <li><i class="bi bi-check"></i> BAG address data found</li>
                    <li><i class="bi bi-check"></i> Coordinates found</li>
                    <li><i class="bi bi-check"></i> BAG addressable object ID found</li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'PENDING'" class="text-secondary">
                        <span class="spinner-border spinner-border-sm" aria-hidden="true"></span>
                        Retrieving energy label…
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'FOUND'">
                        <i class="bi bi-check"></i> EP-Online linked: <span class="notranslate">{{ resolvedAddress.energyLabel }}</span>
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'NOT_FOUND'" class="text-secondary">
                        <i class="bi bi-info-circle"></i> No energy label was found in EP-Online
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'UNAVAILABLE'" class="text-warning">
                        <i class="bi bi-exclamation-triangle"></i> EP-Online is temporarily unavailable and will be tried again after saving
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'CONFIGURATION_ERROR'" class="text-danger">
                        <i class="bi bi-exclamation-triangle"></i> EP-Online is not configured in Flowmaps
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'AUTHENTICATION_FAILED'" class="text-danger">
                        <i class="bi bi-exclamation-triangle"></i> EP-Online rejected the configured API key
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'INVALID_RESPONSE'" class="text-warning">
                        <i class="bi bi-exclamation-triangle"></i> EP-Online returned an invalid response
                    </li>
                    <li *ngIf="resolvedAddress?.epOnlineStatus === 'NETWORK_ERROR'" class="text-warning">
                        <i class="bi bi-exclamation-triangle"></i> EP-Online could not be reached from Flowmaps
                    </li>
                </ul>
            </div>
        </div>

        <div *ngIf="addressStep === 'details'" class="card-body">
            <div class="row">
                <div *ngIf="showOrganisationField" class="col-12 col-md-6">
                    <app-form-field label="Organisation">
                        <app-search [minCharacters]="0" [(ngModel)]="data.entity.organisation" required [searchFunction]="searchOrganisations"
                                    [inputFormatter]="refDataUtils.organisationFormatter" dataKey="info.name" [disabled]="!isNewLocation"
                                    placeholder="Search for an organisation" ></app-search>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Name">
                        <input [(ngModel)]="info.name" type="text" class="form-control">
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Building code">
                        <input [(ngModel)]="info.buildingCode" type="text" class="form-control">
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Department">
                        <input [(ngModel)]="info.department" type="text" class="form-control">
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Object number">
                        <input [(ngModel)]="info.objectNumber" type="text" class="form-control">
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Building type">
                        <app-select [ngModel]="buildingType" (ngModelChange)="onBuildingTypeChange($event)" [formatter]="buildingTypeFormatter"
                                    [selectedFormatter]="buildingTypeFormatter" dataKey="buildingTypeId"
                                    [optionsProvider]="buildingTypes" [nullOption]="!isNewLocation"
                                    [required]="isNewLocation"></app-select>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Energy label">
                        <div class="energy-label-field">
                            <div class="energy-label-control" [class.has-label-info]="!!getEnergyLabelDetails()">
                                <app-select class="notranslate" [(ngModel)]="info.energyLabel"
                                            (ngModelChange)="energyLabelChanged()"
                                            [options]="energyCompassUtils.labels" [nullOption]="true"></app-select>
                                <button #energyLabelTrigger *ngIf="getEnergyLabelDetails()" type="button"
                                        class="btn energy-label-info ep-online-linked"
                                        [title]="energyLabelDetailsTitle()" [attr.aria-label]="energyLabelDetailsTitle()"
                                        [attr.aria-expanded]="energyLabelDetailsOpen"
                                        [attr.aria-controls]="energyLabelDetailsId" [attr.popovertarget]="energyLabelDetailsId" aria-haspopup="dialog"
                                        (click)="toggleEnergyLabelDetails($event, energyLabelTrigger, energyLabelPopup)">
                                    <i class="bi bi-info-circle" aria-hidden="true"></i>
                                </button>
                            </div>
                            <div #energyLabelPopup popover="auto" class="energy-label-details"
                                 (toggle)="energyLabelDetailsOpen = $any($event).newState === 'open'"
                                 [id]="energyLabelDetailsId" role="dialog" [attr.aria-label]="energyLabelDetailsTitle()">
                              <ng-container *ngIf="getEnergyLabelDetails() as officialLabel">
                                    <div class="energy-label-details-heading">
                                        <span>EP-Online</span>
                                        <strong class="notranslate">{{ officialLabel.energyLabel }}</strong>
                                        <button type="button" class="btn-close" [attr.aria-label]="energyLabelCloseTitle()"
                                                (click)="closeEnergyLabelDetails(true)"></button>
                                    </div>
                                    <dl>
                                        <dt>Registered on</dt>
                                        <dd class="notranslate">{{ formatEnergyLabelDate(officialLabel.energyLabelValidity?.start) }}</dd>
                                        <dt>Valid until</dt>
                                        <dd class="notranslate">{{ formatEnergyLabelDate(officialLabel.energyLabelValidity?.end) }}</dd>
                                        <dt>Assessed on</dt>
                                        <dd class="notranslate">{{ formatEnergyLabelDate(officialLabel.energyLabelAssessmentDate) }}</dd>
                                        <dt>Certificate holder</dt>
                                        <dd class="notranslate">{{ officialLabel.energyLabelCertificateHolder || '—' }}</dd>
                                        <dt>Last successful check</dt>
                                        <dd class="notranslate">{{ formatEnergyLabelDate(officialLabel.energyLabelLastCheckedAt, true) }}</dd>
                                    </dl>
                                    <p class="energy-label-explanation mb-0">This energy label is linked to EP-Online through the BAG addressable object ID. Flowmaps periodically checks for a new registration and updates automatically linked labels. Manual selections are preserved.</p>
                              </ng-container>
                            </div>
                        </div>
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="Area">
                        <input [(ngModel)]="info.area" type="number" class="form-control">
                    </app-form-field>
                </div>
                <div class="col-12 col-md-6">
                    <app-form-field label="BAG addressable object ID"
                                    tooltip="Enter the 16-digit BAG addressable object ID so EP-Online can retrieve the corresponding energy-label data. If left blank, the system will try to find it automatically using the postcode and house number. A green check mark means the connection has been established.">
                        <div class="input-group">
                            <input [(ngModel)]="info.cadastreId" (ngModelChange)="closeEnergyLabelDetails()"
                                   type="text" inputmode="numeric" maxlength="16"
                                   pattern="[0-9]{16}" class="form-control">
                            <span *ngIf="isBagIdComplete()" class="input-group-text bag-id-status"
                                  [class.ep-online-linked]="isEpOnlineLinked()"
                                  [class.bag-id-ready]="!isEpOnlineLinked()"
                                  [title]="isEpOnlineLinked() ? 'EP-Online connection verified' : 'BAG ID ready to be checked'"
                                  [attr.aria-label]="isEpOnlineLinked() ? 'EP-Online connection verified' : 'BAG ID ready to be checked'">
                                <i class="bi bi-check-circle-fill"></i>
                            </span>
                        </div>
                    </app-form-field>
                </div>
                <h6 class="header-pretitle mt-3">Address</h6>
                <div *ngIf="addressResolvedAutomatically" class="address-source-banner mb-3">
                    <div>
                        <i class="bi bi-check-circle-fill"></i>
                        <span>Address automatically filled using PDOK</span>
                        <span *ngIf="resolvedAddress?.epOnlineStatus === 'FOUND'">· EP-Online linked</span>
                    </div>
                    <button type="button" class="btn btn-sm btn-link" (click)="reopenAddressLookup()">Change address</button>
                </div>
                <app-address-form class="p-0" [address]="info.address"
                                  [readOnly]="addressResolvedAutomatically"
                                  [collapseGeoLocation]="addressResolvedAutomatically"></app-address-form>
                <h6 class="header-pretitle mt-3">Energy</h6>
                <div class="col-12 col-md-6">
                    <app-form-field label="Fully electric building">
                        <div class="form-check form-switch">
                            <input class="form-check-input" type="checkbox" role="switch" id="allElectricSwitch"
                                   [ngModel]="info.allElectric"
                                   (ngModelChange)="onAllElectricChange($event)">
                            <label class="form-check-label notranslate" for="allElectricSwitch">
                                {{ allElectricStatusLabel() }}
                            </label>
                            <app-tooltip class="ms-2" placement="top">
                                <i class="bi bi-info-circle"></i>
                                <div class="tooltipContent">
                                    Heating and other energy needs are fully covered by electricity. No separate gas or heat connection is required.
                                </div>
                            </app-tooltip>
                        </div>
                    </app-form-field>
                </div>
            </div>
            <section class="location-image-section mt-4" *ngIf="!isNewLocation && appContext.isAdminOrIntermediary()">
                <h6 class="header-pretitle">
                    Location image
                    <app-tooltip class="ms-1" placement="top">
                        <i class="bi bi-info-circle"></i>
                        <div class="tooltipContent">
                            Shown on the cover page of the location reports. Supported file types: JPG, PNG, WebP. Maximum file size: 2 MB.
                        </div>
                    </app-tooltip>
                </h6>
                <div class="location-image-content">
                    <div class="location-image-status" [class.text-muted]="!locationImage">
                        <i class="bi bi-image"></i>
                        <span *ngIf="locationImage" class="notranslate text-truncate">{{ locationImage.fileName }}</span>
                        <span *ngIf="!locationImage">No image selected</span>
                    </div>
                    <div class="location-image-actions">
                        <label class="btn btn-outline-primary mb-0">
                            <i class="bi bi-upload me-2"></i>
                            {{ locationImage ? 'Replace image' : 'Select image' }}
                            <input type="file"
                                   #locationImageInput
                                   class="d-none"
                                   accept="image/jpeg,image/png,image/webp"
                                   (change)="selectLocationImage($event)">
                        </label>
                        <button *ngIf="locationImage" type="button" class="btn btn-outline-danger" (click)="removeLocationImage()">
                            <i class="bi bi-trash me-2"></i>
                            Remove
                        </button>
                    </div>
                    <div *ngIf="locationImageInput.validationMessage" class="location-image-error text-danger small">
                        {{ locationImageInput.validationMessage }}
                    </div>
                </div>
            </section>
            <section class="opening-hours-section mt-4">
                <h6 class="header-pretitle">Opening hours</h6>
                <p class="text-secondary small mb-2">Days you do not change use the standard hours for the selected building type.</p>
                <div class="opening-hours-list">
                    <div class="opening-hours-row" *ngFor="let day of openingHoursRows">
                        <div class="opening-hours-day">
                            <span>{{day.dayOfWeek}}</span>
                        </div>
                        <div class="opening-hours-range">
                            <input [ngModel]="day.start" (ngModelChange)="onOpeningTimeChange(day, 'start', $event)"
                                   type="time" class="form-control" [disabled]="day.closed"
                                   [attr.aria-label]="day.dayOfWeek + ' opening time'">
                            <span class="opening-hours-separator">to</span>
                            <input [ngModel]="day.end" (ngModelChange)="onOpeningTimeChange(day, 'end', $event)"
                                   type="time" class="form-control" [disabled]="day.closed"
                                   [attr.aria-label]="day.dayOfWeek + ' closing time'">
                        </div>
                        <label class="form-check opening-hours-closed mb-0">
                            <input class="form-check-input" type="checkbox" [ngModel]="day.closed"
                                   (ngModelChange)="onClosedChange(day, $event)">
                            <span class="form-check-label">Closed</span>
                        </label>
                        <div *ngIf="isInvalidRange(day)" class="opening-hours-error text-warning small">
                            These opening hours will not be saved; this day returns to the building-type default.
                        </div>
                    </div>
                </div>
                <div *ngIf="hasInvalidOpeningHours()" class="alert alert-warning mt-3 mb-0">
                    Some opening hours were not saved. Incomplete days have returned to the building-type defaults.
                </div>
            </section>
        </div>

        <div *ngIf="addressStep === 'lookup'" class="card-footer">
            <div class="d-flex justify-content-between gap-2">
                <button type="button" class="btn btn-secondary" (click)="requestClose()">Cancel</button>
                <div class="d-flex gap-2">
                    <button type="button" class="btn btn-outline-secondary" (click)="useManualAddress()">Enter manually</button>
                    <button *ngIf="addressLookupState !== 'found'" type="submit" class="btn btn-primary"
                            [disabled]="!canSearchAddress() || addressLookupState === 'searching'">Find address</button>
                    <button *ngIf="addressLookupState === 'found'" type="button" class="btn btn-primary"
                            (click)="useResolvedAddress()">Use these details</button>
                </div>
            </div>
        </div>
        <div *ngIf="addressStep === 'details'" class="card-footer">
            <div class="d-flex justify-content-between">
                <button type="button" class="btn btn-secondary" (click)="requestClose()">Cancel</button>
                <button type="submit" class="btn btn-primary">Save changes</button>
            </div>
        </div>
    </div>
</app-form>
